import defaultTranslations from '@/modules/translations'

export default {
  accountingVenueClasses: [],
  accountingVenueClassesById: {},
  activeItemIds: [],
  activeItems: [],
  aiChatOpen: false,
  allergens: [],
  allergensById: {},
  batches: [],
  bottleAlgosById: {},
  bottles: [],
  bottlesById: {},
  bottlesStockPredictionsById: {},
  bottleStockPredictionsFromSalesById: {},
  categories: [],
  categoriesById: {},
  config: {
    user: null,
    venue_data: {
      batches: [],
      business_types: [],
      liquor_houses: [],
      payment_methods: [],
      reports: []
    }
  },
  countries: [],
  currentPermissionsByType: {},
  currentPlanFeaturesByType: {},
  customFields: [],
  customFieldsById: {},
  customFieldsByTarget: {},
  customFieldsByTargetActive: {},
  darkModeTheme: 0, // 0 = light, 1 = dark, 2 = auto
  dashboardData: {
    health: {},
    inventories: [],
    last_interval: {},
    stock_prediction: {},
    weekly_intakes: []
  },
  dashboardRealtimeData: {},
  deviceInfo: null,
  distributorCredentials: [],
  distributorCredentialsByDistributorId: {},
  distributorPrices: [],
  distributorPricesById: {},
  distributors: [],
  distributorsById: {},
  draftInvoiceExtraLines: [],
  draftInvoiceExtraLinesByDraftInvoiceId: {},
  draftInvoiceLinesByDraftInvoiceId: {},
  draftInvoices: [],
  draftInvoicesById: {},
  uiEditModeActive: true,
  families: [],
  familiesById: {},
  firebaseUser: null,
  firestoreInitialLoadComplete: false,
  glAccounts: [],
  glAccountsById: {},
  globalActions: {},
  gridViews: [],
  gridViewsCore: [],
  infoTooltipsById: {},
  infoTooltipsDirty: false,
  initialDBLoadingProgress: null, //!!! start null, then becomes an object
  initialDBLoadingStats: {},
  inventories: [],
  inventoriesHighLevelLoadAllComplete: false,
  inventoryEntriesByInventoryIdByLocationId: {},
  inventoryLocations: [],
  inventoryLocationsByInventoryId: {},
  itemPricesById: {},
  itemVariantPricesById: {},
  itemVariants: [],
  itemVariantsById: {},
  loadingScreenVisible: false,
  locations: [],
  locationsById: {},
  movementAdjustmentReasons: [],
  movementAdjustmentReasonsById: {},
  movementExtraLineReasons: [],
  movementExtraLineReasonsById: {},
  movements: [],
  movementsById: {},
  notification: null,
  options: {
    intercom_product_tours: [],
    measurements: [],
    onboarding_types: [],
    partial_measuring_types: [],
    permissions: [],
    pos_integration_statuses: [],
    pos_types: [],
    statuses: [],
    timeline_filter_types: [],
    venue_types: []
  },
  orderGuideRawData: [],
  orderGuideVariantIdsMap: {},
  orderGuideLists: [],
  orderGuideListsById: {},
  orders: [],
  pageViewPermissions: {},
  parLevelsById: {},
  permissions: [],
  permissionsById: {},
  posItemCostsById: {},
  posItems: [],
  draftPOSItems: [], //TODO: rename this to posItemsDraft in order to match the alphabetical order (domain pos items, specificity draft)
  posItemsById: {}, // shared by both draft pos items and pos items
  posItemsExtraDataById: {}, // shared by both draft pos items and pos items
  posModifiers: [],
  posModifiersById: {},
  posIntegrations: [],
  quotaExceededError: false,
  recentInventoriesById: {},
  revenueCenters: [],
  revenueCentersById: {},
  roles: [],
  rolesById: {},
  rolesByVenueId: {},
  selectedBottle: null,
  servingSizes: [],
  shoppingCart: [],
  shoppingCartByItemId: {},
  shoppingCartByVariantId: {},
  sidebarMinimized: false,
  signupFlow: null,
  subrecipeCostById: {},
  subrecipeCosts: [],
  subrecipes: [],
  subrecipesById: {},
  subrecipesByInventoryItemId: {},
  adjustmentTypes: [],
  adjustmentTypesById: {},
  taxes: [],
  taxesById: {},
  translations: defaultTranslations,
  user: null,
  venue: null,
  venues: [],
  venuesHighLevel: [],
  venuesHighLevelById: {},
  venueStats: {},
  venueTransfers: [],
  venueTransfersById: {},
  viewRefreshKey: 1,
  waitingForVenue: false,
  windowResizeKey: 1,
  wiskModalLayers: [],
  backgroundJobs: []
}
